"use strict";
var User_1;
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const OsmosysBaseEntity_1 = require("../OsmosysBaseEntity");
const emails_1 = require("../emails");
const UserInvite_1 = require("./UserInvite");
const flight_manager_1 = require("../flight-manager");
const Workspace_1 = require("./Workspace");
const WorkspaceMembership_1 = require("./WorkspaceMembership");
const FeatureFlags_1 = require("../core/FeatureFlags");
let User = User_1 = class User extends OsmosysBaseEntity_1.OsmosysBaseEntity {
};
tslib_1.__decorate([
    type_graphql_1.Field(() => User_1),
    typeorm_1.ManyToOne(() => User_1, {
        cascade: true,
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], User.prototype, "creatingUser", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({
        unique: true,
    }),
    tslib_1.__metadata("design:type", String)
], User.prototype, "email", void 0);
tslib_1.__decorate([
    type_graphql_1.Field({ nullable: true }),
    typeorm_1.Column({ nullable: true }),
    tslib_1.__metadata("design:type", String)
], User.prototype, "fullName", void 0);
tslib_1.__decorate([
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], User.prototype, "password", void 0);
tslib_1.__decorate([
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], User.prototype, "passwordResetToken", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Date, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'timestamp',
    }),
    tslib_1.__metadata("design:type", Object)
], User.prototype, "passwordResetTokenExpiresAt", void 0);
tslib_1.__decorate([
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], User.prototype, "magicLinkToken", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Date, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'timestamp',
    }),
    tslib_1.__metadata("design:type", Object)
], User.prototype, "magicLinkTokenExpiresAt", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    tslib_1.__metadata("design:type", Boolean)
], User.prototype, "hasPassword", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    typeorm_1.Column({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], User.prototype, "isAppAdmin", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [UserInvite_1.UserInvite]),
    typeorm_1.OneToMany(() => UserInvite_1.UserInvite, invite => invite.user, { onDelete: 'CASCADE' }),
    tslib_1.__metadata("design:type", Object)
], User.prototype, "invites", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => UserInvite_1.UserInvite, { nullable: true }),
    typeorm_1.OneToOne(() => UserInvite_1.UserInvite, invite => invite.acceptingUser, {
        nullable: true,
        onDelete: 'CASCADE',
    }),
    typeorm_1.JoinColumn({ name: 'accepted_invite_id' }),
    tslib_1.__metadata("design:type", Object)
], User.prototype, "acceptedInvite", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => UserInvite_1.UserInvite, { nullable: true }),
    typeorm_1.OneToOne(() => UserInvite_1.UserInvite, { nullable: true, onDelete: 'CASCADE' }),
    typeorm_1.JoinColumn({ name: 'latest_invite_id' }),
    tslib_1.__metadata("design:type", Object)
], User.prototype, "latestInvitation", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Workspace_1.Workspace, { nullable: true }),
    typeorm_1.ManyToOne(() => Workspace_1.Workspace, {
        cascade: true,
        nullable: true,
        onDelete: 'SET NULL',
    }),
    typeorm_1.JoinColumn(),
    tslib_1.__metadata("design:type", Object)
], User.prototype, "latestWorkspace", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Number, { nullable: true }),
    typeorm_1.RelationId((obj) => obj.latestWorkspace),
    tslib_1.__metadata("design:type", Object)
], User.prototype, "latestWorkspaceId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [WorkspaceMembership_1.WorkspaceMembership], { nullable: true }),
    typeorm_1.OneToMany(() => WorkspaceMembership_1.WorkspaceMembership, wsMembership => wsMembership.user),
    tslib_1.__metadata("design:type", Object)
], User.prototype, "workspaceMemberships", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [flight_manager_1.Workflow], { nullable: true }),
    typeorm_1.ManyToMany(() => flight_manager_1.Workflow, wf => wf.usersThatCanApprove),
    tslib_1.__metadata("design:type", Object)
], User.prototype, "workflowsToApprove", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [flight_manager_1.Workflow], { nullable: true }),
    typeorm_1.ManyToMany(() => flight_manager_1.Workflow, wf => wf.usersToSendProofsTo),
    tslib_1.__metadata("design:type", Object)
], User.prototype, "workflowProofsSent", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [emails_1.Email], { nullable: true }),
    typeorm_1.ManyToMany(() => emails_1.Email, e => e.assignedUsers),
    tslib_1.__metadata("design:type", Object)
], User.prototype, "emailsAssigned", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Workspace_1.Workspace, { nullable: true }),
    tslib_1.__metadata("design:type", Object)
], User.prototype, "currentWorkspace", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => FeatureFlags_1.FeatureFlags),
    typeorm_1.Column({
        default: new FeatureFlags_1.FeatureFlags(),
        type: 'jsonb',
    }),
    tslib_1.__metadata("design:type", FeatureFlags_1.FeatureFlags)
], User.prototype, "featureFlagOverrides", void 0);
User = User_1 = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    typeorm_1.Entity()
], User);
exports.User = User;
//# sourceMappingURL=User.js.map